import { observer } from 'mobx-react-lite'

import {
  MicrophoneCombobox,
  RingtoneCombobox,
  SpeakerCombobox,
} from '@src/app/components/audio-device'
import type { ThemeKey } from '@src/theme'
import FormField from '@ui/FormField/FormField'

import * as styles from './AudioSettingsForm.css'

interface AudioSettingsFormProps extends React.HTMLProps<HTMLDivElement> {
  allowTesting?: boolean
  tooltipMode?: ThemeKey
}

function AudioSettingsForm({ allowTesting = true, tooltipMode }: AudioSettingsFormProps) {
  return (
    <div className={styles.root}>
      <FormField label="Microphone" className={styles.field}>
        <MicrophoneCombobox themeKey={tooltipMode} />
      </FormField>
      <FormField label="Speaker" className={styles.field}>
        <SpeakerCombobox themeKey={tooltipMode} isTestingEnabled={allowTesting} />
      </FormField>
      <FormField label="Ringtone" className={styles.field}>
        <RingtoneCombobox themeKey={tooltipMode} isTestingEnabled={allowTesting} />
      </FormField>
    </div>
  )
}

export default observer(AudioSettingsForm)
